var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"button-pay-custom",style:(_vm.styles),attrs:{"disabled":_vm.isDisabled,"loading":_vm.loadingSubmit},on:{"click":_vm.handleAction}},[_vm._v(_vm._s(_vm.objectData.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }